import React from 'react';
import { XCircle } from 'lucide-react';
import { symptoms } from '../data/kit';
export function Problem() {
  return <section className="bg-rose-50 py-8 md:py-16 px-4" data-id="element-200" data-mp="2pefolmwyeac9">
      <div className="max-w-3xl mx-auto" data-id="element-201" data-mp="2bfptudxlwmr2">
        <h2 className="font-serif text-[24px] md:text-[40px] font-bold text-center text-wine leading-[1.12] tracking-tight" data-id="element-202" data-mp="2bexxv203kn09">
          QUERÉS AYUDARLO.{' '}
          <span className="block text-rose-600 mt-1" data-id="element-203" data-mp="21pwgp8htfzkp">
            LO QUE FALTA ES SABER CÓMO HACERLO PASO A PASO.
          </span>
        </h2>

        <div className="mt-4 md:mt-7 text-center max-w-xl mx-auto space-y-2.5 md:space-y-3" data-id="element-204" data-mp="26hej80zhm87s">
          <p className="text-[15px] md:text-lg text-ink-muted leading-snug" data-id="element-205" data-mp="1sq9jz0017hxz">
            Conoce algunas letras por separado. Después intenta unir sílabas.
            Se traba con algunas palabras. La práctica empieza a frustrarlo. Y
            vos terminás buscando una actividad diferente cada vez que se
            sientan a leer.
          </p>
          <p className="text-[15px] md:text-lg font-semibold text-ink leading-snug" data-id="element-206" data-mp="t9x3p9tage4f">
            El problema es que tener muchas actividades no significa tener un
            camino claro.
          </p>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 mt-5 mb-6 md:mt-8 md:mb-10" data-id="element-207" data-mp="12ad7ylhuvpac">
          {symptoms.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl border border-rose-200 bg-white px-4 py-3 md:px-5 md:py-4" data-id="element-208" data-mp="xctqlcpv2we6">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-rose-500 shrink-0" data-id="element-209" data-mp="5l5jb4lxx027" />
              <span className="text-ink text-[15px] md:text-base font-medium leading-snug" data-id="element-210" data-mp="jbhe5b9wtcx1">
                {item}
              </span>
            </li>)}
        </ul>

        <div className="text-center max-w-xl mx-auto" data-id="element-211" data-mp="ej7ntu4vuau8">
          <p className="font-serif text-[20px] md:text-[28px] font-bold text-wine leading-tight tracking-tight" data-id="element-212" data-mp="3mzjb3zji5ixg">
            Por eso Desafío Lector no empieza directamente con textos largos.
          </p>
          <p className="text-[15px] md:text-lg font-bold text-rose-700 mt-1.5 leading-snug" data-id="element-213" data-mp="1lxth4dto46vt">
            Primero construye una base. Después aumenta la dificultad paso a
            paso.
          </p>
        </div>
      </div>
    </section>;
}